module.exports = __webpack_public_path__ + "img/reports.5e599bb3.svg";